module.exports = __webpack_public_path__ + "static/media/Profile_7.3b3b60dd.svg";